import {
  ScheduleEntryState,
  Timestamp,
  TranslateFunction,
} from '@griply/types';
import { differenceInDays, endOfDay } from 'date-fns';

import { getDateLabel } from './get-date-label';

export type GetOverduePromptConfigOptions = {
  name: string;
  overdueDate: Timestamp;
  today: Timestamp;
  entryType: ScheduleEntryState;
  t: TranslateFunction;
};

export type OverduePromptConfig = {
  title: string;
  overdueDateLabel: string;
  daysAgoLabel: string;
  todayLabel: string;
};

export const getOverduePromptConfig = ({
  name,
  overdueDate,
  today,
  entryType,
  t,
}: GetOverduePromptConfigOptions): OverduePromptConfig => ({
  title: t(
    `general.labels.task-detail.checkbox.overdue-options.${entryType}.title`,
    { name },
  ),
  overdueDateLabel: getDateLabel(overdueDate, today),
  daysAgoLabel: t('general.labels.days-ago', {
    count: differenceInDays(endOfDay(today), endOfDay(overdueDate)),
  }),
  todayLabel: t('general.labels.dates.today'),
});
